import { render, staticRenderFns } from "./AttributeCategoryManager.vue?vue&type=template&id=48a7d156&scoped=true"
import script from "./AttributeCategoryManager.vue?vue&type=script&lang=js"
export * from "./AttributeCategoryManager.vue?vue&type=script&lang=js"
import style0 from "./AttributeCategoryManager.vue?vue&type=style&index=0&id=48a7d156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7d156",
  null
  
)

export default component.exports